export interface RouteNamesType {
  Home: string;
  Invoices: string;
  Orders: string;
  OrderQuotes: string;
  OrderDrafts: string;
  OrderImport: string;
  CreateOrder: string;
  Deliveries: string;
  Returns: string;
  Products: string;
  Promotions: string;
  Marketing: string;
  Feeds: string;
  InboundIntegrations: string;
  OutboundIntegrations: string;
  IntegrationEvents: string;
  RestApiGroup: string;
  RestApiDocs: string;
  RestApiKeys: string;
  FileSftpDetails: string;
  Reports: string;
  Team: string;
  Account: string;
  AdvertisingConfiguration: string;
}

const Routes: RouteNamesType = {
  Home: 'home',
  Invoices: 'invoices',
  Orders: 'orders',
  OrderQuotes: 'orders/quotes',
  OrderDrafts: 'orders/drafts',
  CreateOrder: 'orders/create',
  OrderImport: 'orders/import',
  Deliveries: 'deliveries',
  Returns: 'returns',
  Products: 'products',
  Promotions: 'promotions',
  Marketing: 'marketing',
  Feeds: 'feeds',
  InboundIntegrations: 'inbound-integrations',
  OutboundIntegrations: 'outbound-integrations',
  IntegrationEvents: 'integration-events',
  RestApiGroup: 'public-rest-api',
  RestApiDocs: 'public-rest-api/docs',
  RestApiKeys: 'public-rest-api/keys',
  FileSftpDetails: 'public-file-api/details',
  Reports: 'reports',
  Team: 'team',
  Account: 'account',
  AdvertisingConfiguration: 'advertising/configurations'
};

export default Routes;
